import { ReactNode, useState } from 'react';
import { Card } from '../../../shared/components';

export function KpiPanelShell({ title, subtitle, children }: { title: string; subtitle?: string; children: ReactNode }) {
  const [visible, setVisible] = useState(true);
  return (
    <Card>
      <div className="mb-3 flex items-center justify-between">
        <div>
          <h3 className="text-[15px] font-semibold text-ink-800">{title}</h3>
          {subtitle && <p className="text-xs text-ink-400">{subtitle}</p>}
        </div>
        <button
          onClick={() => setVisible((v) => !v)}
          className="rounded-lg border border-ink-200 px-3 py-1.5 text-xs font-medium text-ink-600 hover:bg-ink-50"
        >
          {visible ? 'Ocultar' : 'Mostrar'}
        </button>
      </div>
      {visible && children}
    </Card>
  );
}
